import { z } from 'zod';
/** docs section 4 "First Login" — a small, admin-configurable step sequence.
 * State is a completed-steps set stored as a tenant setting; there is no
 * separate state machine table to keep this simple for V1. */
export const ONBOARDING_STEPS = ['profile', 'company', 'configure', 'first_lead'];
export const completeOnboardingStepSchema = z.object({
    step: z.enum(ONBOARDING_STEPS),
});
export const onboardingStatusResponseSchema = z.object({
    requiredSteps: z.array(z.enum(ONBOARDING_STEPS)),
    completedSteps: z.array(z.enum(ONBOARDING_STEPS)),
    isComplete: z.boolean(),
});
//# sourceMappingURL=schemas.js.map